/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Client-specific threshold or configuration value for this IoE check. Type varies by check.
 * @export
 * @interface GetAllIoes200ResponseIoeInnerSetting
 */
export interface GetAllIoes200ResponseIoeInnerSetting {
}

/**
 * Check if a given object implements the GetAllIoes200ResponseIoeInnerSetting interface.
 */
export function instanceOfGetAllIoes200ResponseIoeInnerSetting(value: object): value is GetAllIoes200ResponseIoeInnerSetting {
    return true;
}

export function GetAllIoes200ResponseIoeInnerSettingFromJSON(json: any): GetAllIoes200ResponseIoeInnerSetting {
    return GetAllIoes200ResponseIoeInnerSettingFromJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllIoes200ResponseIoeInnerSetting {
    return json;
}

export function GetAllIoes200ResponseIoeInnerSettingToJSON(json: any): GetAllIoes200ResponseIoeInnerSetting {
    return GetAllIoes200ResponseIoeInnerSettingToJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerSettingToJSONTyped(value?: GetAllIoes200ResponseIoeInnerSetting | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

